import React from 'react';
import { Heading } from '../../../_lib/components/Heading/Heading';
import { AttachedFilesBaseList } from '../../../_lib/components/AttachedFilesBase';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { IFileItem } from '../../../types/api/FileItem';

type ThreadAttachmentListDefaultProps = {
  attachments: IFileItem[];
};

export function ThreadAttachmentListDefault({ attachments }: ThreadAttachmentListDefaultProps) {
  const { t } = useSonTranslation('Posts');

  if (attachments?.length === 0) {
    return null;
  }

  return (
    <div className="posts__attachements-container">
      <Heading className="invisible" hierarchy={5}>
        {t('default.attachedfiles.headline.uploaded')}
      </Heading>
      <AttachedFilesBaseList attachments={attachments} backgroundTransparent />
    </div>
  );
}
